<div class="layoutBlock detailpage tabMenueDetailpage">
	<div class="detailpageSideLeft"></div>
	<div class="detailpageCenter">
	    <div *ngIf="detailViewListEntries[entityId]?.getOverSearchResultLink()">
            <a class="searchResultListTitle" [href]="hrefPrefix + detailViewListEntries[entityId].getOverSearchResultLink().target"
                title="{{detailViewListEntries[entityId].getOverSearchResultLink().text}}" hisImage="{{detailViewListEntries[entityId].getOverSearchResultLink().icon}}">
                {{detailViewListEntries[entityId].getOverSearchResultLink().text | hisUi}}
            </a><br><br>
        </div>
		<div  class="layoutBlock">
            <his-search-result
                class="columnFullWidth"
                #searchResultComponent
                [search]="search"
                [isSearchFormResult]="true"
                [showTitle]="true"
                [showNewSearchButton]="false"
                [showChangeSearchButton]="false"
                defaultActionUrl="https://orcid.org/:id"
                [hisIcon]="'arrow_right'"
                [singleSelect]="false"
                [multiSelect]="true"
                [resultRowsPerPage]="10"
                [ignoreForBackToSearchResultNavigation]="true"
                [resultListTemplate]="showList ? resultListTemplate : null"
                [loadLastSortOrder]="false">
                <ng-template #resultListTemplate let-data let-first="first" let-total="totalRecords" let-rows="rowsPerPage">
                    <div *ngIf="detailViewListEntries[entityId] && data" class="layoutblock searchresultListContainer">
                        <ul class="searchResultList">
                            <li *ngFor="let entry of data; let i = index" class="resultListDetail">
                                <!-- 0th line -->
                                <div *ngIf="detailViewListEntries[entityId].getSubheading(entry, data, i)">
                                    <h2>{{detailViewListEntries[entityId].getSubheading(entry, data, i)}}</h2>
                                    <br>
                                </div>

                                <!-- 1st line -->
                                <div  *ngIf="detailViewListEntries[entityId].getHeaderLine(entry)">{{detailViewListEntries[entityId].getHeaderLine(entry)}}</div>

                                <!-- 2nd line (with link) -->
                                <div *ngIf="detailViewListEntries[entityId].getTitleLink(entry) && detailViewListEntries[entityId].getTitleLine(entry)">
                                    <a class="searchResultListTitle" (click)="onBeforeNavigate()" [href]="hrefPrefix + detailViewListEntries[entityId].getTitleLink(entry)"
                                        title="{{detailViewListEntries[entityId].getToolTip(entry)}}">
                                        <his-translated-text *ngIf="entityId === 'projects';else notProjects"
                                            [hisobject]= "getHisObjectWithForeignTextsForAttribute(entry, entityId , 'title', 'defaulttext')"
                                            [hisAttribute]="'defaulttext'">
                                        </his-translated-text>  
                                        <ng-template #notProjects>
                                            <his-translated-text
                                                [hisobject]= "getHisObjectWithForeignTextsForAttribute(entry, entityId , 'title', 'title')"
                                                [hisAttribute]="'title'">
                                            </his-translated-text>                                          
                                        </ng-template>                                       
                                    </a>                                    
                                </div>
                                    
                                <div *ngIf="!detailViewListEntries[entityId].getTitleLink(entry) && detailViewListEntries[entityId].getTitleLine(entry)">
                                    <a class="searchResultListTitle disabledLink" >
                                    <his-translated-text [hisobject]="getHisObjectWithForeignTextsForAttribute(entry, entityId ,
                                     getParameterName(entry), getParameterName(entry))" hisAttribute="{{getParameterName(entry)}}"></his-translated-text>
                                    </a></div>
                                <!-- 3rd line (with collapse/expand buttons) -->
                                <div *ngIf="detailViewListEntries[entityId].getExtendableLine(entry, i, first, rows)" class="searchResultListDetail">
                                    <span>
                                        {{detailViewListEntries[entityId].getExtendableLine(entry, i, first, rows)}}
                                        <button *ngIf="detailViewListEntries[entityId].isExtendable(entry) && isShowAll(extendableLineShowAll, i, first, rows)" (click)="setShowAll(extendableLineShowAll, false,i, first, rows)" hisImage="ARROW_UP_V" class="icon button-more" [title]="'view.images.minus_circ' | hisUi"></button>
                                        <button *ngIf="detailViewListEntries[entityId].isExtendable(entry) && !isShowAll(extendableLineShowAll, i, first, rows)" (click)="setShowAll(extendableLineShowAll, true,i, first, rows)" hisImage="ARROW_DOWN_V" class="icon button-more" [title]="'view.images.plus_circ' | hisUi"></button>
                                    </span>
                                </div>
                                <!-- 4rd line (with collapse/expand buttons) -->
                                <div *ngIf="detailViewListEntries[entityId].getExtendableLineSecond(entry, i, first, rows)" class="searchResultListDetail">
                                    <span>
                                        {{detailViewListEntries[entityId].getExtendableLineSecond(entry, i, first, rows)}}
                                        <button *ngIf="detailViewListEntries[entityId].isExtendableSecond(entry) && isShowAll(extendableLineShowAllSecond, i, first, rows)" (click)="setShowAll(extendableLineShowAllSecond,false,i, first, rows)" hisImage="ARROW_UP_V" class="icon button-more" [title]="'view.images.minus_circ' | hisUi"></button>
                                        <button *ngIf="detailViewListEntries[entityId].isExtendableSecond(entry) && !isShowAll(extendableLineShowAllSecond, i, first, rows)" (click)="setShowAll(extendableLineShowAllSecond,true,i, first, rows)" hisImage="ARROW_DOWN_V" class="icon button-more" [title]="'view.images.plus_circ' | hisUi"></button>
                                    </span>
                                </div>

                                <!-- 5th line -->
                                <div *ngIf="detailViewListEntries[entityId].getFooterLine(entry)" class="subline">{{detailViewListEntries[entityId].getFooterLine(entry)}}</div>
                            </li>
                        </ul>

                        <div class="ui-paginator">
                            <p-paginator [first]="first" [rows]="rows" [totalRecords]="total" [templateRight]="templateRight" (onPageChange)="paginate($event)">
                                <ng-template #templateRight>
                                    <div *ngIf="total > 0">
                                        <his-search-result-rows-per-page
                                            [resultRowsPerPage]="searchResultComponent.resultRowsPerPage"
                                            [rowsPerPage]="searchResultComponent.rowsPerPage"
                                            [maxRows]="searchResultComponent.maxRows"
                                            (rowsPerPageInputChanged)="searchResultComponent.rowsPerPageChanged($event)"
                                            [resultRowsPerPage]="searchResultComponent.resultRowsPerPage"
                                            [totalRowCount]="searchResultComponent.totalRowCount"
                                            [currentPageNumber]="searchResultComponent.currentPageNumber"
                                            [totalNumberOfPages]="searchResultComponent.totalNumberOfPages">
                                        </his-search-result-rows-per-page>
                                    </div>
                                </ng-template>
                            </p-paginator>
                        </div>
                        <p></p>
                    </div>
                    <div class="searchresultListpageRight"><!--Platzhalter--></div>
                </ng-template>
            </his-search-result>
        </div>
    </div>
</div>
